import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/languageCode/list',
    method: 'get',
    params: params
  })
}

export function listAll() {
  return request({
    url: '/languageCode/listAll',
    method: 'get'
  })
}

export function listAllEnabled() {
  return request({
    url: '/languageCode/listAllEnabled',
    method: 'get'
  })
}

export function createLanguage(data) {
  return request({
    url: '/languageCode/create',
    method: 'post',
    data: data
  })
}

export function updateLanguage(id, data) {
  return request({
    url: '/languageCode/update/' + id,
    method: 'post',
    data: data
  })
}

export function deleteLanguage(id) {
  return request({
    url: '/languageCode/delete/' + id,
    method: 'get'
  })
}

export function deleteBatch(ids) {
  return request({
    url: '/languageCode/delete/batch',
    method: 'post',
    params: { ids: ids }
  })
}

export function refreshCache() {
  return request({
    url: '/languageCode/refreshCache',
    method: 'post'
  })
}

export function supportedLangs() {
  return request({
    url: '/languageCode/supportedLangs',
    method: 'get'
  })
}

export function initI18n(data) {
  return request({
    url: '/languageCode/initI18n',
    method: 'post',
    data: data
  })
}

export function getModules() {
  return request({
    url: '/languageCode/modules',
    method: 'get'
  })
}

export function migrateAttrOptions() {
  return request({
    url: '/languageCode/migrateAttrOptions',
    method: 'post'
  })
}

export function migrateSkuAttrs() {
  return request({
    url: '/languageCode/migrateSkuAttrs',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/languageCode.js